module.exports = __webpack_public_path__ + "static/pid-ug-17-en-home-8dc9dc316b3c4a95b9482f91856c77a5.png";